import { createContext, ReactNode, useContext } from 'react';
import { useDocument } from '../../context';
import { ICancelDialogResult, useDialog } from '@tap/tap-ui';
import { ApiTimeTrackingLog, IApiIssue } from '@tap/data-providers';
import EditQCResultDialog from './EditQCResultDialog';
import DeleteQCResultDialog from './DeleteQCResultDialog';
import { UseFetchDataState } from '@tap/mui-ui';

/*
*   Провайдер для QCREsult
*/

export type QCResultContextValue = {
    openAddQCResultDialog: (issueState: UseFetchDataState<IApiIssue>) => void,
    openEditQCResultDialog: (issueState: UseFetchDataState<IApiIssue>, item: ApiTimeTrackingLog) => void,
    openDeleteQCResultDialog: (issueState: UseFetchDataState<IApiIssue>, item: ApiTimeTrackingLog) => void,
    //timeTrackingLogProps: TimeTrackingLogProps,
}

export const QCResultContext = createContext<QCResultContextValue | null>(null);

export type QCResultProviderProps = {
    children?: ReactNode,
}


export const QCResultProvider = ({ children }: QCResultProviderProps): JSX.Element => {

    const { documentKey, documentState } = useDocument();

    const handleCloseDialog = ({ isCancel }: ICancelDialogResult) => {
        if (!isCancel) {
            documentState.fetchData();
        }
    };

    const EditQCResultReadyDialog = useDialog(EditQCResultDialog, handleCloseDialog);
    const DeleteQCResultReadyDialog = useDialog(DeleteQCResultDialog, handleCloseDialog);

    const openAddQCResultDialog = (issueState: UseFetchDataState<IApiIssue>) => {
        EditQCResultReadyDialog.open({ documentKey, issueState });
    }

    const openEditQCResultDialog = (issueState: UseFetchDataState<IApiIssue>, item: ApiTimeTrackingLog) => {
        EditQCResultReadyDialog.open({ documentKey, issueState, item });
    }

    const openDeleteQCResultDialog = (issueState: UseFetchDataState<IApiIssue>, item: ApiTimeTrackingLog) => {
        DeleteQCResultReadyDialog.open({ documentKey });
    }

    //const timeTrackingLogProps = useTimeTrackingLog({ openAddQCResultDialog, openEditQCResultDialog, openDeleteQCResultDialog });

    return (
        <QCResultContext.Provider
            value={{
                openAddQCResultDialog,
                openEditQCResultDialog,
                openDeleteQCResultDialog,
                //timeTrackingLogProps,
            }}
        >
            {children}
            <EditQCResultReadyDialog.Component />
            <DeleteQCResultReadyDialog.Component />
        </QCResultContext.Provider>
    );
};

export const useQCResult = (): QCResultContextValue => {
    const context = useContext(QCResultContext);

    if (context == null) {
        throw new Error('No QCResultContext provided');
    }

    return context;
};

